// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-toolbar {
  padding: 0 12px;
  --background: var(--ion-color-primary);
}
ion-toolbar ion-icon {
  height: 22px;
  width: 22px;
}
ion-toolbar ion-title {
  font-family: AppFontSemiBold;
  font-size: 16px;
  font-weight: 500;
  line-height: 19.44px;
  text-align: left;
  color: var(--color-white);
}
ion-toolbar ion-icon {
  color: var(--color-white);
  fill: var(--color-white);
  --icon-color: var(--color-white);
}`, "",{"version":3,"sources":["webpack://./src/app/components/account-toolbar/account-toolbar.component.scss"],"names":[],"mappings":"AAAA;EACC,eAAA;EACA,sCAAA;AACD;AAAC;EACC,YAAA;EACA,WAAA;AAEF;AAAC;EACC,4BAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,yBAAA;AAEF;AACC;EACC,yBAAA;EACA,wBAAA;EACA,gCAAA;AACF","sourcesContent":["ion-toolbar {\n\tpadding: 0 12px;\n\t--background: var(--ion-color-primary);\n\tion-icon {\n\t\theight: 22px;\n\t\twidth: 22px;\n\t}\n\tion-title {\n\t\tfont-family: AppFontSemiBold;\n\t\tfont-size: 16px;\n\t\tfont-weight: 500;\n\t\tline-height: 19.44px;\n\t\ttext-align: left;\n\t\tcolor: var(--color-white);\n\t}\n\n\tion-icon {\n\t\tcolor: var(--color-white);\n\t\tfill: var(--color-white);\n\t\t--icon-color: var(--color-white);\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
